import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { organizationUsers, resetPasswordAdmin } from "../../redux/UserActions";

const ResetPassword = (props) => {
  const user_mail = useParams()._id;
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(organizationUsers());
  }, []);

  return (
    <div className="flex-initial flex-col lg:w-1/3 md:w-1/2 mx-auto shadow justify-center rounded-lg mt-6">
      <h1 className="text-lg font-medium text-center shadow bg-gray-100 rounded-t-lg py-2">
        Reset User Password
      </h1>
      <div className="flex flex-col justify-center m-4">
        <label className="text-gray-900">Enter new password:</label>
        <input
          className="rounded-lg text-gray-700 border-gray-400 "
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setSubmitted(false);
          }}
        />
      </div>
      <div className="grid lg:grid-cols-5 gap-3 sm:grid-cols-1 m-4 pb-4">
        {submitted === false ? (
          <Fragment>
            <NavLink
              className="focus:outline-none text-white py-3 px text-md font-medium rounded-md text-center bg-red-500 hover:bg-red-600 hover:shadow-md"
              to="/user_management"
            >
              Cancel
            </NavLink>
            <button
              className="lg:col-start-5 sm:col-start-1 focus:outline-none text-white py-3 text-md font-medium rounded-md bg-green-500 hover:bg-green-600 hover:shadow-md"
              onClick={() => {
                setSubmitted(true);
                dispatch(
                  resetPasswordAdmin({
                    mail: user_mail,
                    password: password,
                    token: "admin_reset",
                  })
                );
              }}
            >
              Submit
            </button>
          </Fragment>
        ) : (
          <p>{user.resetPasswordAdminMessage}</p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
